import React from "react";
import RevealAnimation from "../RevealAnimation";

// GrowRyteHero and VentureRyteHero only actually share this left-column
// skeleton (brand + title + optional subtitle + description + button slot).
// Their visual-right illustrations are genuinely different and stay local
// to each component.
const PracticeHeroContent = ({ brand, title, subtitle, description, children }) => (
  <div className="content-left">
    <RevealAnimation component="div" className="hero-brand">
      <span className="brand-logo">{brand}</span>
    </RevealAnimation>

    <RevealAnimation component="h1" className="hero-title" delay={0.1}>
      {title}
    </RevealAnimation>

    {subtitle && (
      <RevealAnimation component="h2" className="hero-subtitle" delay={0.15}>
        {subtitle}
      </RevealAnimation>
    )}

    <RevealAnimation component="p" className="hero-description" delay={0.2}>
      {description}
    </RevealAnimation>

    {children}
  </div>
);

export default PracticeHeroContent;
